import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import { BsEye, BsPencilSquare, BsTrash } from 'react-icons/bs';
import { string } from 'slate';
import TableLoader from './Loader/TableLoader';

interface Item {
    id: number;
    category: string;
    sub_category?: string;
    title: string;
    author: string;
    status: string;
    // Add more properties as per your item structure
}

interface currentDraftsTableProps {
    items: Item[];
    loading: boolean;
    onView: (id: number) => void;
    onEdit: (id: number) => void;
    onDelete: (id: number) => void;
    author?: string | undefined | null
}

export default function CurrentDraftsTable({ items, loading, onView, onEdit, onDelete, author }: currentDraftsTableProps) {
    const [draftsPage, setDraftsPage] = useState(1);
    const draftsPerPage = 10;
    const pendingItems = items.filter(item => item.status === 'Pending' && (item.author === author || author === undefined));
    const indexOfLastDraft = draftsPage * draftsPerPage;
    const indexOfFirstDraft = indexOfLastDraft - draftsPerPage;
    // const currentDrafts = items.slice(indexOfFirstDraft, indexOfLastDraft);
    const currentDrafts = pendingItems.slice(indexOfFirstDraft, indexOfLastDraft);
    const totalPages = Math.ceil(pendingItems.length / draftsPerPage);
    const hasMatchingDrafts = currentDrafts.some(item => item.status === 'Pending');

    const nextDraftsPage = () => {
        if (draftsPage < totalPages) { 
            setDraftsPage(draftsPage + 1); 
        }
    };

    const prevDraftsPage = () => {
        if (draftsPage > 1) { 
            setDraftsPage(draftsPage - 1); 
        }
    };

    return (
        <>  {loading ?
                (
                    <TableLoader />
                )

                :

                (
                    <table>
                        <thead className="bg-gray-200">
                            <tr>
                                <th style={{ width: '20%' }}>Category</th>
                                <th style={{ width: '20%' }}>Sub Category</th>
                                <th style={{ width: '20%' }}>Title</th>
                                <th style={{ width: '20%' }}>Author</th>
                                <th style={{ width: '10%' }}>Status</th>
                                <th style={{ width: '10%' }} className="text-center">Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentDrafts.length !== 0 ?
                                (
                                    currentDrafts.map(item => (
                                        item.status === 'Pending' && (item.author === author) && (
                                            <tr key={item.id}>
                                                <td>{item.category}</td>
                                                <td>{item.sub_category}</td>
                                                <td>{item.title}</td>
                                                <td>{item.author}</td>
                                                <td>{item.status}</td>
                                                <td>
                                                    <button onClick={() => onView(item.id)} className='bg-red-600 rounded-sm text-white text-xl' data-tooltip-id='preview'><BsEye /></button>
                                                    <span> </span>
                                                    <button onClick={() => onEdit(item.id)} className='bg-red-600 rounded-sm text-white text-xl' data-tooltip-id='edit'><BsPencilSquare /></button>
                                                    <span> </span>
                                                    <button onClick={() => onDelete(item.id)} type='button' className='bg-gray-600 rounded-sm text-white text-xl' data-tooltip-id='delete'><BsTrash /></button>
                                                </td>
                                            </tr>
                                        )
                                    ))
                                )

                                :

                                (
                                    <tr>
                                        <td colSpan={6} className="text-center">No data available!</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                )
            }
            
            {totalPages > 1 && (
                <div className="flex justify-center items-center mt-4 space-x-4">
                    <button
                        onClick={() => setDraftsPage(1)}
                        className="px-3 py-1 rounded bg-gray-500 text-white disabled:opacity-50"
                        disabled={draftsPage === 1}>
                        First
                    </button>

                    <button
                        onClick={prevDraftsPage}
                        className="px-3 py-1 rounded bg-gray-500 text-white disabled:opacity-50"
                        disabled={draftsPage === 1}>
                        Prev
                    </button>

                    {[...Array(totalPages)].map((_, index) => {
                        const pageNum = index + 1;
                        const inRange = Math.abs(pageNum - draftsPage) <= 1;
                        const isFirstOrLast = pageNum === 1 || pageNum === totalPages;

                        if (inRange || isFirstOrLast) {
                        return (
                            <button
                            key={pageNum}
                            onClick={() => setDraftsPage(pageNum)}
                            className={`px-3 py-1 rounded ${
                                draftsPage === pageNum
                                ? "bg-red-600 text-white"
                                : "bg-gray-200 text-black"
                            }`}
>
                            {pageNum}
                            </button>
                        );
                        }

                        if (
                        (pageNum === draftsPage - 2 || pageNum === draftsPage + 2) &&
                        totalPages > 5
                        ) {
                        return (
                            <span key={`ellipsis-${pageNum}`} className="px-2 text-gray-500">
                            ...
                            </span>
                        );
                        }

                        return null;
                    })}

                    <button
                        onClick={nextDraftsPage}
                        className="px-3 py-1 rounded bg-red-500 text-white disabled:opacity-50"
                        disabled={draftsPage === totalPages}>
                        Next
                    </button>

                    <button
                        onClick={() => setDraftsPage(totalPages)}
                        className="px-3 py-1 rounded bg-red-500 text-white disabled:opacity-50"
                        disabled={draftsPage === totalPages}>
                        Last
                    </button>
                </div>
            )}
        </>
    )
}